import type { AllSeriesItem } from './types';

export function getAllSeriesThumbImgSrc(series: AllSeriesItem): string {
  return series.thumbnail.processed_url;
}
